<div class="object-form">
  <form (ngSubmit)="onSubmit(f)" #f="ngForm">
    <div class="object-form__sub-form">

      <!-- VCS Source -->
      <div class="object-form__field">
        <div class="input-field">
          <div class="input-field__label">
            <label for="vcsSource">Gegevensbron <span>*</span></label>
          </div>
          <div class="input-field__input input-field__input--list">
            <select id="vcsSource" name="vcsSource" required
              (ngModelChange)="onSourceChange($event)"
              [ngModel]="selectedSource">
              <option [ngValue]="null" disabled>Kies een bron...</option>
              @for (source of vcsSources; track source) {
                <option [ngValue]="source">{{ source.name }}</option>
              }
            </select>
          </div>
        </div>
      </div>

      <!-- Git Repository (conditioneel) -->
      @if (repositories.length > 0) {
        <div class="object-form__field">
          <div class="input-field">
            <div class="input-field__label">
              <label for="gitRepository">Repository <span>*</span></label>
            </div>
            <div class="input-field__input input-field__input--list">
              <select id="gitRepository" name="gitRepository" required
                (ngModelChange)="onRepositoryChange($event)"
                [ngModel]="selectedRepository">
                <option [ngValue]="null" disabled>Kies een repository...</option>
                @for (repo of repositories; track repo) {
                  <option [ngValue]="repo">{{ repo.name }}</option>
                }
              </select>
            </div>
          </div>
        </div>
      }

      <!-- Branch (conditioneel) -->
      @if (branches.length > 0) {
        <div class="object-form__field">
          <div class="input-field">
            <div class="input-field__label">
              <label for="gitBranch">Branch <span>*</span></label>
            </div>
            <div class="input-field__input input-field__input--list">
              <select id="gitBranch" name="gitBranch" required
                (ngModelChange)="onBranchChange($event)"
                [ngModel]="selectedBranch">
                <option [ngValue]="null" disabled>Kies een branch...</option>
                @for (branch of branches; track branch) {
                  <option [ngValue]="branch">{{ branch.name }}</option>
                }
              </select>
            </div>
          </div>
        </div>
      }

      <!-- Name -->
      <div class="object-form__field">
        <div class="input-field">
          <div class="input-field__label">
            <label for="name">Naam <span>*</span></label>
          </div>
          <div class="input-field__input input-field__input--text">
            <input type="text" id="name" name="name" #nameField="ngModel"
              ngModel required maxlength="255">
            @if (nameField.touched && !nameField.valid) {
              <span class="input-field__warning">Verplicht veld</span>
            }
          </div>
        </div>
      </div>

      <!-- Description -->
      <div class="object-form__field">
        <div class="input-field">
          <div class="input-field__label">
            <label for="description">Omschrijving</label>
          </div>
          <div class="input-field__input input-field__input--textblock">
            <textarea name="description" [(ngModel)]="descriptionValue"></textarea>
          </div>
        </div>
      </div>

    </div>

    <input type="submit" value="Opslaan" [disabled]="!f.valid || submitDisabled">
    <input type="button" value="Annuleren" (click)="onCancel()">
  </form>
</div>
